import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import { useGetAllStatesQuery } from "../../states/statesApi";
import SelectField from "../../../../components/common/form/SelectField";
import { createOptionListForSelectTag } from "../../../../helpers/utils/Utils";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import { useGetAllCountyByStateIdQuery } from "../../counties/countiesApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import CommonChosenInput from "../../../order/editor/Sections/CommonChosenInput";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { useUpdateSubDivisionMutation } from "../subDivisionApi";
import {useGetEnumsQuery} from "../../../../app/globalApi";


type SubdivisionDetailInfoProps = {
    subdivisionData: any;
    showButtons?: any;
    setShowButtons?: any;
    aliases?: any;
    setAliases?: any;
    onSubmit?: any;
    subdivisionsData?: any;
    setSubdivisionData?: any;
    updateApiResponse?: any;
    isReadOnly?: any
};

const SubdivisionDetailInfo: FC<SubdivisionDetailInfoProps> = ({ isReadOnly, subdivisionData, showButtons, setShowButtons, aliases, setAliases, onSubmit, subdivisionsData, setSubdivisionData, updateApiResponse }) => {

    const [showMore, setShowMore] = useState(false);
    const statesApiResult = useGetAllStatesQuery("");
    const countiesApiResult = useGetAllCountyByStateIdQuery(subdivisionsData?.state?.value ?? skipToken);
    const { data: enums } = useGetEnumsQuery("");

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;

        setSubdivisionData((prevData: any) => ({
            ...prevData,
            [name]: value,

        }));
        setShowButtons(true);
    };
    const handCancel = async (e?: React.MouseEvent<HTMLButtonElement>) => {
        e?.preventDefault();
        setShowButtons(false);
    };





    return (

        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md">
            <Form
                onSubmit={async (e: any) => {
                    e.preventDefault()
                    await onSubmit(subdivisionsData)
                }}
                fields={
                    <>
                        <div className="flex justify-between items-center  border-b border-[rgba(0,0,0,0.1)] p-2">
                            <h5 className="font-semibold text-surface-0">Subdivision Details
                            </h5>
                            {showButtons && !isReadOnly && (
                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => handCancel(),
                                                type: "close",
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: "Update Subdivision",
                                                type: "submit",
                                                isLoading: (updateApiResponse.isLoading),
                                            },
                                            buttonType: "button",
                                        }
                                    ]}
                                    align="end"
                                    gap={2}
                                />
                            )}
                        </div>

                        <div className="p-2">
                            <InputField name="name"
                                label="Name" value={subdivisionsData?.name || ""}
                                onChange={handleOnChange}
                                required
                                placeholder="Enter Name..." disabled={isReadOnly}

                            />


                            <div className="col-span-12 grid grid-cols-12 gap-3">
                                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                    <label className="min-w-[100px]">Unit / Phase / Section</label>
                                </div>
                                <div className="relative col-span-9 flex items-center gap-3">
                                    <div className="w-full">
                                        <InputField
                                            hideLabel
                                            placeholder="Enter Unit..."
                                            type="text"
                                            name={"unit"}
                                            value={subdivisionsData?.unit || ""}
                                            onChange={handleOnChange}
                                            disabled={isReadOnly}

                                        />
                                    </div>
                                    <div className="w-full">
                                        <InputField
                                            label="Phase"
                                            placeholder="Enter Phase..."
                                            type="text"
                                            name={"phase"}
                                            value={subdivisionsData?.phase || ""}
                                            onChange={handleOnChange}
                                            disabled={isReadOnly}

                                            hideLabel={true}
                                        />
                                    </div>
                                    <div className="w-full">
                                        <InputField
                                            label="Section"
                                            placeholder="Enter Section..."
                                            type="text"
                                            name={"section"}
                                            value={subdivisionsData?.section || ""}
                                            onChange={handleOnChange}
                                            disabled={isReadOnly}

                                            hideLabel={true}
                                        />
                                    </div>
                                </div>
                            </div>


                            <InputField name="subdivisionLabel"
                                label="Subdivision Label"
                                type="text"
                                value={subdivisionsData?.subdivisionLabel || ""}
                                onChange={handleOnChange}
                                required
                                disabled={true}
                            />

                            <SelectField
                                placeholder="Select State..."
                                value={subdivisionsData?.state}
                                options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "id")}
                                onChange={(selectedOption) => handleOnChange({ name: "state", value: selectedOption })}
                                label="Select State"
                                required
                                isDisabled={isReadOnly}

                            />

                            <SelectField
                                placeholder="Select County..."
                                value={subdivisionsData?.counties?.[0]} // Use first county from array
                                options={createOptionListForSelectTag(countiesApiResult?.data, "countyName", "id")}
                                onChange={(selectedOption) => handleOnChange({ name: "counties", value: selectedOption })}
                                label="County"
                                isDisabled={isReadOnly}

                            />

                            <InputField name="city"
                                label="City"
                                type="text"
                                value={subdivisionsData?.city || ""}
                                onChange={handleOnChange} disabled={isReadOnly}

                            />

                            <InputField name="subdivisionCode"
                                label="Subdivision Code"
                                type="text"
                                value={subdivisionsData?.subdivisionCode || ""}
                                onChange={handleOnChange} disabled={isReadOnly}
                            />

                            <div className="grid grid-cols-12 gap-3 py-2">
                                <div className="col-span-3 font-medium text-sm pt-2"><label>Aliases</label></div>
                                <div className="col-span-9">
                                    <CommonChosenInput
                                        placeholder={"Enter Aliases..."}
                                        state={aliases}
                                        setState={setAliases}
                                        isRequired={false}
                                        setEditable={setShowButtons}
                                        isDisable={isReadOnly}
                                    />
                                </div>
                            </div>

                            <button type="button" className="text-highlight-4 text-md  mt-2"
                                onClick={() => setShowMore(!showMore)}>
                                {showMore ? "Show Less" : "Show More..."}
                            </button>


                            {showMore && (
                                <div className="mt-3 ">
                                    <InputField name="acreage"
                                        label="Acreage"
                                        type="text"
                                        value={subdivisionsData?.acreage || ""}
                                        onChange={handleOnChange} disabled={isReadOnly}

                                    />

                                    <InputField name="titleAbstract"
                                        label="Title Abstract"
                                        type="text"
                                        value={subdivisionsData?.titleAbstract || ""}
                                        onChange={handleOnChange}
                                        disabled={isReadOnly}


                                    />

                                    <InputField name="survey"
                                        label="Survey"
                                        type="text"
                                        value={subdivisionsData?.survey || ""}
                                        onChange={handleOnChange}
                                        disabled={isReadOnly}


                                    />

                                    <InputField name="platNumber"
                                        label="Plat No."
                                        type="text"
                                        value={subdivisionsData?.platNumber || ""}
                                        onChange={handleOnChange}
                                        disabled={isReadOnly}


                                    />

                                    <SelectField
                                        placeholder='Select Plat Status...'
                                        value={subdivisionsData?.platStatus || null}
                                        options={createOptionListForSelectTag(enums?.["PlatStatus"], "value", "constant")}
                                        onChange={(selectedOption) => {
                                            handleOnChange({ name: "platStatus", value: selectedOption })
                                        }}
                                        label={"Plat Status"}
                                        isDisabled={isReadOnly}
                                    />

                                    <InputField name="expectedTaxYear"
                                        label="Expected Tax Year"
                                        type="text"
                                        value={subdivisionsData?.expectedTaxYear || ""}
                                        onChange={handleOnChange}
                                        disabled={isReadOnly}

                                    />


                                    <InputField name="expectedTaxYearAlt"
                                        label="Expected Tax Year Alt"
                                        type="text"
                                        value={subdivisionsData?.expectedTaxYearAlt || ""}
                                        onChange={handleOnChange}
                                        disabled={isReadOnly}


                                    />
                                </div>
                            )}

                        </div>
                    </>
                }
            />
        </div>

    );
}
export default SubdivisionDetailInfo;

